import { Fragment, useEffect, useRef, useState } from "react";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid"
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";

import { sendFax } from "../../../../../features/fax/fax";

import { inputValueToInt } from "../../../../../utils/utils"

import { Checkbox, FormControl, FormControlLabel, MenuItem, OutlinedInput, Radio, Select } from "@mui/material";
import PdfPreview from "../../../../../components/PdfPreview";
import { createVerticalOrderFormPDF } from "../../../../../features/pdf/VerticalOrderFormPDF";
import { createHorizontalOrderFormPDF } from "../../../../../features/pdf/HorizontalOrderFormPDF";
import { SelectDestinationDrawer } from "../../../../../components/drawers/SelectDestinationDrawer";
import { createVerticalOrderCheckFormPDF } from "../../../../../features/pdf/VerticalOrderCheckFormPDF";
import { createHorizontalOrderCheckFormPDF } from "../../../../../features/pdf/HorizontalOrderCheckFormPDF";
import { postMarketPriceUpdateShippingDateInfoAPI } from "../../../../../http/api/MarketPriceAPI";
import { getShopsGroupingByCustomer } from "../../../../../utils/customerShop";
import { createGeneralOrderFormPDF } from "../../../../../features/pdf/GeneralOrderFormPDF";
import { createGeneralOrderCheckFormPDF } from "../../../../../features/pdf/GeneralOrderCheckFormPDF";
import { getUsingDirectorEmployeePartition, getUsingDeliveryPrice, validatePrintPageStr } from "../../../../../utils/orderForm";
import { controlPdfSettingConstraint } from "./SettingConstraints";

// FAXダイアログ　出力設定
export function OrderNumberPdfSettingPart({onLoadPdfSetting, shippingDateIsInterval, onChangePdfSetting}) {

  // 印刷ページ入力State
  const [printPageInput, setPrintPageInput] = useState("");

  const [pdfSetting, setPdfSetting] = useState(onLoadPdfSetting());
 
  // 送り状として出力State
  const [asSendingLabel, setAsSendinglabel] = useState(false);

  const onChangePdfPropSetting = (prop) => (event) => {
    let newPdfSetting = {...pdfSetting, [prop]: event.target.value};

    onChangePdfSetting(controlPdfSettingConstraint(newPdfSetting, shippingDateIsInterval, asSendingLabel));
    setPdfSetting(controlPdfSettingConstraint(newPdfSetting, shippingDateIsInterval, false));
  }

  const onChangePdfSettingWithArray = (settingArray) => (event) => {
    let newPdfSetting = {...pdfSetting, ...settingArray};

    onChangePdfSetting(controlPdfSettingConstraint(newPdfSetting, shippingDateIsInterval, asSendingLabel));
    setPdfSetting(controlPdfSettingConstraint(newPdfSetting, shippingDateIsInterval, false));
  }

  const toggleSetting = (prop) => (event) => {
    let newPdfSetting = {...pdfSetting, [prop]: event.target.checked};
    
    onChangePdfSetting(controlPdfSettingConstraint(newPdfSetting, shippingDateIsInterval, asSendingLabel));
    setPdfSetting(controlPdfSettingConstraint(newPdfSetting, shippingDateIsInterval, false));
  }

  const toggleAsSeningLabel = (event) => {
    const asSendingLabelValue = event.target.checked;
    setAsSendinglabel(asSendingLabelValue);
    onChangePdfSetting(controlPdfSettingConstraint({...pdfSetting}, shippingDateIsInterval, asSendingLabelValue));
  }

  const onChangePrintPageInput = (event) => {
    setPrintPageInput(event.target.value);
  }

  const appliedSetting = controlPdfSettingConstraint(pdfSetting, shippingDateIsInterval, asSendingLabel)

  return (
    <Box border='black 1px solid' padding={1} paddingBottom={0}>
      <Typography>出力形式設定</Typography>
      <Grid container>
        <Grid item xs={7.5}>
          <table>
            <tr>
              <td>
                <Typography fontWeight={600}>列数・向き</Typography>
              </td>
              <td colSpan={2}>
                <FormControl>
                  <Select
                    sx={{ width: 200 }}
                    value={appliedSetting.orderFormColumnCountDirectionCd}
                  >
                    <MenuItem
                      key={"column-direction-col-1-vertcal"}
                      value={"1"}
                      onClick={onChangePdfSettingWithArray({orderFormColumnCountDirectionCd: "1", columnNumber : "1", direction : "1", general: "2"})}
                    >
                      1列・縦むき
                    </MenuItem>
                    <MenuItem
                      key={"column-direction-col-1-horizontal"}
                      value={"3"}
                      onClick={onChangePdfSettingWithArray({orderFormColumnCountDirectionCd: "3", columnNumber : "1", direction : "2", general: "2"})}
                    >
                      1列・横むき
                    </MenuItem>
                    <MenuItem
                      key={"column-direction-col-2-vertical"}
                      onClick={onChangePdfSettingWithArray({orderFormColumnCountDirectionCd: "5", columnNumber : "2", direction : "1", general: "2"})}
                      value={"5"}
                    >
                      2列・縦むき
                    </MenuItem>
                    <MenuItem
                      key={"column-direction-col-2-horizontal"}
                      value={"2"}
                      onClick={onChangePdfSettingWithArray({orderFormColumnCountDirectionCd: "2", columnNumber : "2", direction : "2", general: "2"})}
                    >
                      2列・横むき
                    </MenuItem>
                    <MenuItem
                      key={"column-direction-col-3-horizontal"}
                      value={"4"}
                      onClick={onChangePdfSettingWithArray({orderFormColumnCountDirectionCd: "4", columnNumber : "3", direction : "2", general: "1", shopSummary: "1"})}
                      disabled={appliedSetting.isUsingSellingPrice || appliedSetting.isUsingDeliveryPrice}
                    >
                      3列・横むき
                    </MenuItem>
                  </Select>
                </FormControl>
              </td>
              <td colSpan={3}>
                <FormControlLabel
                  control={
                    <Checkbox
                      value={asSendingLabel}
                      onChange={toggleAsSeningLabel}
                    />
                  }
                  label="送り状として出力"												
                />
              </td>                  
            </tr>
            <tr>
              <td width="150px">
                <Typography fontWeight={600}>店舗表示</Typography>
              </td>
              <td width="130px">
                <FormControlLabel
                  value="1"
                  control={<Radio />}
                  label="1店舗ごと"
                  checked={appliedSetting.shopSummary === "1"}
                  onChange={onChangePdfPropSetting("shopSummary")}
                />
              </td>
              <td  width="130px">
                <FormControlLabel
                  value="2"
                  control={<Radio />}
                  label="まとめる"
                  checked={appliedSetting.shopSummary === "2"}
                  disabled={
                    (appliedSetting.direction == "1" && appliedSetting.columnNumber == "2")
                      || (appliedSetting.direction == "2" && appliedSetting.columnNumber == "3")
                      || appliedSetting.datePartition
                      || asSendingLabel
                  }
                  onChange={onChangePdfPropSetting("shopSummary")}
                />
              </td>
              <td width="150px">
                <Typography fontWeight={600}>種別ごと改ページ</Typography>
              </td>
              <td width="130px">
                <FormControlLabel
                  value="1"
                  control={<Radio />}
                  label="する"
                  checked={appliedSetting.productTypePartition === "1"}
                  onChange={onChangePdfPropSetting("productTypePartition")}
                />
              </td>
              <td width="130px">
                <FormControlLabel
                  value="2"
                  control={<Radio />}
                  label="しない"
                  checked={appliedSetting.productTypePartition === "2"}
                  onChange={onChangePdfPropSetting("productTypePartition")}
                />
              </td>
            </tr>
            <tr>
              <td>
                <Typography fontWeight={600}>締め切り時間出力</Typography>
              </td>
              <td>
                <FormControlLabel
                  value="1"
                  control={<Radio />}
                  label="する"
                  checked={appliedSetting.deadlineHourOutput === "1"}
                  onChange={onChangePdfPropSetting("deadlineHourOutput")}
                />
              </td>
              <td>
                <FormControlLabel
                  value="2"
                  control={<Radio />}
                  label="しない"
                  checked={appliedSetting.deadlineHourOutput === "2"}
                  onChange={onChangePdfPropSetting("deadlineHourOutput")}
                />
              </td>
              <td>
                <Typography fontWeight={600}>個人連絡先出力</Typography>
              </td>
              <td>
                <FormControlLabel
                  value="1"
                  control={<Radio />}
                  label="する"
                  checked={appliedSetting.contact === "1"}
                  onChange={onChangePdfPropSetting("contact")}
                />
              </td>
              <td>
                <FormControlLabel
                  value="2"
                  control={<Radio />}
                  label="しない"
                  checked={appliedSetting.contact === "2"}
                  onChange={onChangePdfPropSetting("contact")}
                />
              </td>
            </tr>
          </table>
        </Grid>
        <Grid item xs={4.5}>
          <Grid container>
            <Grid item xs={6}>
              <FormControlLabel
                control={<Checkbox />}
                label="注文のない商品を表示しない"
                checked={appliedSetting.skipNoOrder}
                onChange={toggleSetting("skipNoOrder")}
                disabled={asSendingLabel}
              />
            </Grid>
            <Grid item xs={6}>
              <FormControlLabel
                control={<Checkbox />}
                label="注文単位を表示しない"
                checked={appliedSetting.skipOrderUnit}
                onChange={toggleSetting("skipOrderUnit")}
              />
            </Grid>
            <Grid item xs={6}>
              <FormControlLabel
                control={<Checkbox />}
                label="日付別に分ける"
                checked={appliedSetting.datePartition}
                onChange={toggleSetting("datePartition")}
                disabled={appliedSetting.columnNumber !== "1" || !shippingDateIsInterval || asSendingLabel}
              />
            </Grid>
            <Grid item xs={6}>
              <FormControlLabel
                control={<Checkbox />}
                label="備考を表示しない"
                checked={appliedSetting.skipRemark}
                onChange={toggleSetting("skipRemark")}
              />
            </Grid>
            <Grid item xs={6} display={(appliedSetting.isUsingSellingPrice && appliedSetting.isUsingDeliveryPrice) ? 'inherid' : 'none'}>
              <FormControlLabel
                control={<Checkbox />}
                label="営業用に出力する"
                checked={appliedSetting.isViewOriginalCost}
                onChange={toggleSetting("isViewOriginalCost")}
              />
            </Grid>
            <Grid item xs={6}>
              <FormControlLabel
                control={<Checkbox />}
                label="担当者で分ける"
                checked={appliedSetting.directorEmployeePartition === "1"}
                onChange={toggleSetting("directorEmployeePartition")}
                disabled={asSendingLabel}
              />
            </Grid>
          </Grid>					
        </Grid>			
      </Grid>
      <hr />
      <Grid container alignItems="center" spacing={1} marginBottom={1}>
        <Grid item xs="auto">
          <FormControlLabel
            control={<Checkbox />}
            label="再送"
            checked={appliedSetting.isSendingAgain}
            onChange={toggleSetting("isSendingAgain")}
          />
        </Grid>
        <Grid item xs="auto">
          <Typography fontWeight={600}>印刷ページ</Typography>
        </Grid>
        <Grid item xs="auto">
          <OutlinedInput
            value={printPageInput}
            onChange={onChangePrintPageInput}
          />
        </Grid>
        <Grid item xs="auto">
          <Button
            variant="contained"
            onClick={onChangePdfSettingWithArray({...appliedSetting, printPageStr: printPageInput})}
            disabled={!validatePrintPageStr(printPageInput)}
          >変更</Button>
        </Grid>
        <Grid item xs="auto" marginLeft={1}>
          <Typography>
            (例: 1-3,8,10-12)
          </Typography>
        </Grid>
      </Grid>  
    </Box>
  )
}
